'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var FormHiddenField = _react2['default'].createClass({
    displayName: 'FormHiddenField',


    propTypes: {
        'name': _react2['default'].PropTypes.string,
        'value': _react2['default'].PropTypes.string
    },

    render: function render() {
        return _jsx('input', {
            type: 'hidden',
            name: this.props.name,
            value: this.props.value
        });
    }

});

var FormField = _react2['default'].createClass({
    displayName: 'FormField',


    propTypes: {
        'type': _react2['default'].PropTypes.string.isRequired,
        'name': _react2['default'].PropTypes.string.isRequired,
        'value': _react2['default'].PropTypes.string,
        'attributes': _react2['default'].PropTypes.object
    },

    render: function render() {

        var tag;
        var attrs = this.props.attributes || {};

        switch (this.props.type) {

            case 'input':
                attrs.type = 'text';
                attrs.value = attrs.value || this.props.value;
                attrs.name = this.props.name;
                tag = _react2['default'].DOM.input;
                break;

            case 'inputcheckbox':
                attrs.type = 'checkbox';
                attrs.checked = attrs.checked || (this.props.value ? 'checked' : undefined);
                attrs.name = this.props.name;
                tag = _react2['default'].DOM.input;
                break;

            case 'inputfile':
                attrs.type = 'file';
                attrs.value = attrs.value || this.props.value;
                attrs.name = this.props.name;
                tag = _react2['default'].DOM.input;
                break;

            case 'inputpassword':
                attrs.type = 'password';
                attrs.value = attrs.value || this.props.value;
                attrs.name = this.props.name;
                tag = _react2['default'].DOM.input;
                break;

            case 'select':
                attrs.value = attrs.value || this.props.value;
                attrs.name = this.props.name;
                tag = _react2['default'].DOM.select;
                break;

            case 'selectmany':
                attrs.value = attrs.value || this.props.value;
                attrs.name = this.props.name;
                attrs.multiple = 'multiple';
                tag = _react2['default'].DOM.select;
                break;

            case 'selectradio':
                attrs.type = 'radio';
                attrs.value = attrs.value || this.props.value;
                attrs.name = this.props.name;
                tag = _react2['default'].DOM.input;
                break;

            case 'textarea':
                attrs.value = attrs.value || this.props.value;
                attrs.name = this.props.name;
                tag = _react2['default'].DOM.textarea;
                break;

            default:
                throw new Error('Form field type not supported: ' + this.props.type);

        }

        return tag(attrs);
    }

});

var BaseFormSpecs = {

    displayName: 'CustomForm',

    propTypes: {
        'name': _react2['default'].PropTypes.string, // Form name
        'method': _react2['default'].PropTypes.string, // Form method (POST, GET, ...)
        'action': _react2['default'].PropTypes.string, // Form target
        'fields': _react2['default'].PropTypes.array.isRequired, // name => field info
        'values': _react2['default'].PropTypes.object, // name => value
        'errors': _react2['default'].PropTypes.object, // { 'global': [...], 'named': { name => message } }
        'namespace': _react2['default'].PropTypes.string // Namespace pattern for field names
    },

    getInitialState: function getInitialState() {
        return {
            'errors': this.props.errors,
            'hasErrors': this.props.errors && (this.props.errors.global || this.props.errors.named)
        };
    },

    getFieldName: function getFieldName(field) {
        if (field) {
            var token = (field.options ? field.options.id_format : undefined) || '%s';
            return this.props.namespace.replace(token, field.name);
        }
    },

    getFieldValue: function getFieldValue(field) {
        var v = this.props.values ? this.props.values[field.name] : undefined;
        if (v === undefined && field['default']) {
            v = field['default'];
        }
        return v;
    },

    renderHiddenFields: function renderHiddenFields() {

        var hiddenFields = [];
        var k;
        var v;
        var t;
        var field;

        // Render hidden input fields
        for (k in this.props.fields) {
            field = this.props.fields[k];
            if (field && field.options.is_hidden) {
                v = this.getFieldValue(field);
                t = parseInt(Math.random() * Math.pow(10, 6), 10);
                hiddenFields.push(_jsx(FormHiddenField, {
                    name: this.getFieldName(field),
                    value: v
                }, 'hidden-field-' + t));
            }
        }

        return hiddenFields;
    },

    renderCsrfField: function renderCsrfField() {

        var k;
        var v;
        var field;

        for (k in this.props.fields) {
            field = this.props.fields[k];
            if (field && field.name === _hfReactHelper2['default'].HfConstants.csrfFieldName) {
                v = this.getFieldValue(field);
                return _jsx(FormHiddenField, {
                    name: this.getFieldName(field),
                    value: v
                });
            }
        }
    },

    renderField: function renderField(name, attributes) {
        if (this.props.fields) {

            var field;
            var k;

            for (k in this.props.fields) {
                if (this.props.fields[k] && this.props.fields[k].name === name) {
                    field = this.props.fields[k];
                    break;
                }
            }

            if (field) {

                if (field.attributes) {
                    // Rewrite some of the attributes to deal with React
                    for (k in field.attributes) {
                        if (k === 'class') {
                            field.attributes.className = field.attributes['class'];
                            delete field.attributes['class'];
                        }
                    }
                }

                var v = this.getFieldValue(field);

                return _jsx(FormField, {
                    name: this.getFieldName(field),
                    type: field.type,
                    value: v,
                    attributes: attributes
                });
            }
        }
    },

    renderErrorText: function renderErrorText() {
        if (this.state.errors) {
            if (this.state.errors.global) {
                return _jsx('p', {}, void 0, this.state.errors.global);
            } else if (this.state.errors.named) {
                var errs = [];
                for (var k in this.state.errors.named) {
                    if (this.state.errors.named[k]) {
                        errs.push(_jsx('p', {}, 'error-' + k, this.state.errors.named[k]));
                    }
                }
                return errs;
            }
        }
    },

    renderFormTag: function renderFormTag(formContent) {
        return _jsx('form', {
            name: this.props.name,
            method: this.props.method,
            action: this.props.action
        }, void 0, formContent);
    },

    getFormData: function getFormData() {
        // Should be implemented by the actual form component
        return null;
    },

    submitAsync: function submitAsync(okCallback, errCallback) {

        var data = this.getFormData();
        var method;

        if (data === null) {
            data = {};
            $('input, select, textarea', _reactDom2['default'].findDOMNode(this)).each(function () {
                var el = $(this);
                var name = el.attr('name');
                if (name) {
                    if (el.attr('type') === 'checkbox') {
                        data[name] = el.prop ? el.prop('checked') : el.attr('checked') === 'checked';
                    } else {
                        data[name] = el.val();
                    }
                }
            });
        }

        $.ajax({
            'context': this,
            'url': this.props.action,
            'type': this.props.method || 'POST',
            'dataType': 'json',
            'data': data,
            'success': okCallback,
            'error': errCallback
        });
    }
};

exports.createFormClass = function () {
    var specs = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];


    // Copy to prevent the original from being altered
    var baseSpecs = (0, _lodash.extend)({}, BaseFormSpecs);

    if (specs.getInitialState) {
        var baseGetInitialStates = baseSpecs.getInitialState;
        var extGetInitialStates = specs.getInitialState;
        specs.getInitialState = function () {
            var baseStates = baseGetInitialStates.call(this);
            var extStates = extGetInitialStates.call(this);
            return (0, _lodash.extend)(baseStates, extStates);
        };
    }

    if (specs.propTypes) {
        var basePropTypes = (0, _lodash.extend)({}, baseSpecs.propTypes); // Copy
        specs.propTypes = (0, _lodash.extend)(basePropTypes, specs.propTypes);
    }

    var comp = _react2['default'].createClass((0, _lodash.extend)(baseSpecs, specs));

    return comp;
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/components/base-form.jsx
 ** module id = 613
 ** module chunks = 0
 **/